import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import App from './App';
import AuthProvider from "./contexts/AuthContext";
import { ServiceDisabledScreen } from './pages/service-disabled/service-disabled.component';

const serviceDisabled = process.env.REACT_APP_SERVICE_DISABLED === 'true';

ReactDOM.render(
    serviceDisabled ? (
        <ServiceDisabledScreen />
    ) : (
        <AuthProvider>
            <App/>
        </AuthProvider>
    ),
    document.getElementById('root')
);


